export default "__VITE_ASSET__CzKnhUcE__"